import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  selectContentFeature,
  toggleEditContentTabNameEditor,
} from "ContentActions";
import AppIcons from "AppIcons";

class ContentFeatureItem extends Component {
  constructor(props) {
    super(props);
    // this.state = { click: false };
  }

  onMenuClick() {
    // this.setState({click: true});
    this.props.selectContentFeature(this.props.feature);
    this.props.toggleEditContentTabNameEditor(false);

    var path = _.lowerCase(this.props.feature.bsClass);
    this.props.history.push(`/dashboard/content/${path}`);
  }

  render() {
    let { contentDashboard, feature } = this.props;
    let status = false;
    // let {click} = this.state;
    // if(click){
    //   var className = "list-group-item content-features-li-active";
    // }else{
    //   var className = "list-group-item content-features-li";
    // }

    if (contentDashboard && contentDashboard[feature.bsClass]) {
      status = true;
    }
    if (
      feature.bsClass == "polls" ||
      feature.bsClass == "attendee" ||
      feature.bsClass == "gamification" ||
      feature.bsClass == "advertisement"
    ) {
      status = true;
    }

    var bsClass = _.lowerCase(feature.bsClass);

    if (
      _.endsWith(bsClass, "s") &&
      bsClass !== "news" &&
      bsClass !== "maps" &&
      bsClass !== "polls"
    ) {
      bsClass = bsClass.substr(0, bsClass.length - 1);
    }

    var iconUrl = `../../style/images/content-icons/content-${bsClass}${
      this.props.selected ? "-Selected" : ""
    }.png`;
    var dragUrl = "../../style/images/drag_sign.png";

    return (
      <li
        // style={{ width: 196, marginLeft: 9 }}
        className={
          this.props.selected
            ? "list-group-item content-features-li-active"
            : "list-group-item content-features-li"
        }
        onClick={this.onMenuClick.bind(this)}
      >
        {/* <img
          src={dragUrl}
          className="drag_sign_image"
          style={{ position: "absolute", left: -27 }}
        /> */}
        {/* <img src={iconUrl} /> */}
        <div className={`sub-menu-icons`}>
          {bsClass === "gamification"
            ? AppIcons[`content_${bsClass}`]
            : AppIcons[bsClass]}
        </div>
        <span className="sub-menu-name">
          {feature.bsClass == "polls"
            ? _.startCase("polls")
            : feature.bsClass == "community"
            ? _.startCase("community")
            : _.startCase(feature.iconName)}
        </span>
        {status ? (
          ""
        ) : (
          <OverlayTrigger
            key="refresh"
            placement="top"
            overlay={
              <Tooltip id="tooltip-manage">
                <span className="tag-label-effect-time">
                  Add{" "}
                  {_.lowerCase(feature.bsClass).substr(
                    0,
                    feature.bsClass.length
                  )}{" "}
                  record!
                </span>
              </Tooltip>
            }
          >
            <i
              className="fa fa-exclamation-circle"
              aria-hidden="true"
              style={{ float: "right", color: "red", margin: 7 }}
            ></i>
          </OverlayTrigger>
        )}
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var pathName = _.startCase(_.last(_.split(ownProps.location.pathname, "/")));
  var pathName1 = _.last(_.split(ownProps.location.pathname, "/"));

  return {
    selected:
      ownProps.feature.bsClass == pathName ||
      ownProps.feature.bsClass == pathName1,
    contentDashboard: state.contentDashboard.data,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    selectContentFeature,
    toggleEditContentTabNameEditor,
  })(ContentFeatureItem)
);
